import { Injectable } from '@angular/core';
import { TranslatorService } from '../services/utils/translator.service';

@Injectable()
export class ErrorFormatter {

  constructor(public translator: TranslatorService) {
  }

  formatErrors(errors: any[]): string {
    let errorsReturned = '';
    if (!errors) {
      return errorsReturned;
    }
    for (const error of errors) {
      if (this.isString(error.message)) {
        errorsReturned += `${this.translator.trans(error.message)}<br/>`;
      } else {
        errorsReturned = this.getMessageErrorOfObject(error.message.message);
      }

    }

    return errorsReturned;
  }

  private getMessageErrorOfObject(messages: any[]): string {
    let errorsMessage = '';
    for (const message of messages) {
      for (const constraint in message.constraints) {
        if (Object.prototype.hasOwnProperty.call(message.constraints, constraint)) {
          errorsMessage += `${this.translator.trans(message.constraints[constraint])}<br/>`;
        }
      }
    }

    return errorsMessage;
  }

  private isString(messageError: any): boolean {
    return typeof messageError === 'string' || messageError instanceof String;
  }
}
